var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2C7EAE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M930.39 320c4.324 0 7.61 4.245 7.61 9.755 0 8.942-5.622 15.264-11.935 18.245l-2.422-4.697c5.19-2.62 7.87-7.587 7.87-10.477-.345.27-1.037.451-1.816.451-3.632 0-6.054-2.89-6.054-6.593 0-3.523 2.508-6.684 6.746-6.684zm-17.558 0c4.325 0 7.611 4.245 7.611 9.755 0 8.942-5.621 15.264-11.935 18.245L906 343.303c5.276-2.62 7.957-7.587 7.957-10.477-.346.27-1.038.451-1.903.451-3.546 0-5.968-2.89-5.968-6.593 0-3.523 2.422-6.684 6.746-6.684z",
    transform: "translate(-906 -320)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.127e4e5d.svg";
export { ForwardRef as ReactComponent };